import {
  ShareSummariesRequest,
  ShareSummariesResponse
} from '@/types/distributionGroupTypes';
import { getDistributionGroups } from './distributionGroupService';

// Mock API base URL - will be replaced with actual backend endpoints

/**
 * Shares generated summaries with specified distribution groups
 */
export const shareSummaries = async (
  request: ShareSummariesRequest,
  getAccessTokenSilently: any,
  getAccessTokenWithPopup: any
): Promise<ShareSummariesResponse> => {
  // TODO: Replace with actual API call
  // const token = await getAccessTokenSilently();
  // const response = await fetch(`${API_BASE_URL}/summaries`, {
  //   method: 'POST',
  //   headers: {
  //     'Content-Type': 'application/json',
  //     Authorization: `Bearer ${token}`
  //   },
  //   body: JSON.stringify(request)
  // });
  // return await response.json();

  // Mock implementation with delay to simulate API call
  await new Promise((resolve) => setTimeout(resolve, 1500));

  // Simulate some email delivery scenarios
  const totalRecipients = request.distributionGroupIds.length * 3; // Assume 3 recipients per group on average
  const failureRate = Math.random() * 0.1; // 0-10% failure rate
  const failedCount = Math.floor(totalRecipients * failureRate);
  const successCount = totalRecipients - failedCount;

  const failedEmails =
    failedCount > 0
      ? ['invalid@example.com', 'bounced@oldcompany.com'].slice(0, failedCount)
      : undefined;

  return {
    success: failedCount === 0,
    message:
      failedCount === 0
        ? `Successfully shared ${request.summaryIds.length} summaries with ${successCount} recipients across ${request.distributionGroupIds.length} distribution groups`
        : `Shared summaries with ${successCount} recipients. ${failedCount} emails failed to deliver.`,
    sharedCount: successCount,
    failedRecipients: failedEmails
  };
};

/**
 * Gets available distribution groups for sharing based on the current template's summaries
 */
export const getAvailableDistributionGroups = async (
  templateId: number,
  companyId: string,
  getAccessTokenSilently: any,
  getAccessTokenWithPopup: any
): Promise<
  Array<{
    id: number;
    name: string;
    description: string;
    recipientCount: number;
    associatedSummaries: string[];
  }>
> => {
  // Fetch all distribution groups for the company and map to UI shape
  // Note: associatedSummaries requires junction data that is not yet exposed;
  // returning an empty list for now.
  const groups = await getDistributionGroups(
    companyId,
    getAccessTokenSilently,
    getAccessTokenWithPopup
  );

  return groups.map((g) => ({
    id: g.id,
    name: g.name,
    description: g.description,
    recipientCount: Array.isArray(g.emailAddresses)
      ? g.emailAddresses.length
      : 0,
    associatedSummaries: []
  }));
};
